import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useCurrentUserAccess } from "../hooks/useCurrentUserAccess";

export default function AdminRoute({ children }) {
  const { accessLoading, isAdminUser } = useCurrentUserAccess();

  if (accessLoading) {
    return (
      <Box sx={{ p: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <CircularProgress size={18} />
          <Typography variant="body2" color="text.secondary">
            Checking access...
          </Typography>
        </Stack>
      </Box>
    );
  }

  if (!isAdminUser) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          User management is admin-only.
        </Alert>
      </Box>
    );
  }

  return children;
}
